import axios from "axios";
import EmptyList from "Components/EmptyList";
import Layout from "Components/Layout/Layout";
import List from "Components/List";
import LoadingIndicator from "Components/LoadingIndicator";
import RootNavigation from "Navigation/RootNavigation";
import moment from "moment";
import { useState } from "react";
import { UserReport, UserReportType } from "../../system/Domain";
import useAxiosEffect from "../../system/useAxiosEffect";
import useChannel from "../../system/useChannel";
import useEvent from "../../system/useEvent";
import useQuery, { IQuery } from "../../system/useQuery";
import ReportsSidebar from "./ReportsSidebar";
import UserReportListItem from "./UserReportListItem";

export interface ReportsQuery extends IQuery {
	types?: UserReportType[];
	dateFrom?: string;
	all?: boolean;
}

export default () => {
	const [query, setQuery, , resetQuery] = useQuery<ReportsQuery>("userReportsQuery", {
		skip: 0,
		take: 200,
		dateFrom: moment().subtract(2, "weeks").startOf("day").toISOString(true),
	});

	const [userReports, setUserReports] = useState<UserReport[]>();

	const [loadingUserReports, loadUserReports] = useAxiosEffect(
		async (config) => {
			const { data } = await axios.post<UserReport[]>(
				`/api/user-reports/search`,
				{
					types: query.types,
					dateFrom: query.dateFrom,
					all: query.all,
				},
				config,
			);
			setUserReports(data);
		},
		[query],
	);

	useChannel("user-reports");

	useEvent(
		"user-report:created",
		async (data) => {
			if (!query.types || query.types.includes(data.type)) {
				await loadUserReports();
			}
		},
		[query],
	);

	useEvent(
		"user-report:updated",
		async (data) => {
			const { id, version } = data;

			if (!userReports || !id || !version) return;

			const userReport = userReports.find((r) => r.id === id);

			if (!userReport || userReport.version < version) {
				await loadUserReports();
			}
		},
		[userReports],
	);

	return (
		<Layout
			title="Reports"
			navigation={<RootNavigation />}
			sidebar={<ReportsSidebar query={query} setQuery={setQuery} resetQuery={resetQuery} />}
		>
			<List>
				{userReports?.length === 0 && <EmptyList />}
				{userReports?.map((r) => (
					<UserReportListItem key={r.id} userReport={r} />
				))}
			</List>
			{loadingUserReports && <LoadingIndicator />}
		</Layout>
	);
};
